import { TranslationKey } from 'state/intl/types';
import { getDesignToken } from 'styles/constants';
const componentTheme = {
  buttonContrastColor: getDesignToken('color-contrast-background'),
  points: 'crownPoints' as TranslationKey,
};

export default componentTheme;
